import styled, { css } from 'styled-components/macro';

const Cell = styled('td')<{ textTransform?: string; color?: string }>`
  padding: ${({ theme }): string => theme.spacing.xsmall};
  ${({ textTransform }): any =>
    textTransform &&
    css`
      text-transform: ${textTransform};
    `}
  ${({ color }): any =>
    color &&
    css`
      color: ${color};
    `}

  &:first-of-type {
    padding-left: 0;
  }

  &:last-of-type {
    padding-right: 0;
  }
`;

export default Cell;
